export const getGradientColor = (value: number): string => {
  let red = 0;
  let green = 0;
  let blue = 0;

  // Helper: clamp and lerp
  const clamp = (v: number, min: number, max: number) => Math.max(min, Math.min(max, v));
  const lerp = (start: number, end: number, t: number) => Math.round(start + (end - start) * t);

  // If value is between 0 and 100 (Red to Green)
  if (value <= 100) {
    red = Math.round(255 - value * 2.55); // Decrease red as the value increases, Red → Green
    green = Math.round(value * 2.55); // Increase green as the value increases
  } else {
    // After 100, transition from Green to Purple or Darker Purple
    // We'll use purple-ish colors
    const t = clamp((value - 100) / 100, 0, 1); // normalize excess to 0–1

    const fromColor = { r: 0, g: 255, b: 0 }; // Green
    const toColor = { r: 148, g: 78, b: 167 }; // Target purple

    red = lerp(fromColor.r, toColor.r, t);
    green = lerp(fromColor.g, toColor.g, t);
    blue = lerp(fromColor.b, toColor.b, t);
  }

  const toHex = (x: number) => x.toString(16).padStart(2, "0");
  return `#${toHex(red)}${toHex(green)}${toHex(blue)}`;
};
